import { render, staticRenderFns } from "./HotelOrderItemize.vue?vue&type=template&id=553919cb&scoped=true"
import script from "./HotelOrderItemize.vue?vue&type=script&lang=js"
export * from "./HotelOrderItemize.vue?vue&type=script&lang=js"
import style0 from "./HotelOrderItemize.vue?vue&type=style&index=0&id=553919cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553919cb",
  null
  
)

export default component.exports